import React from "react";
import { useLang } from "../../context/LanguageContext";

export default function Footer() {
  const { t, lang, setLang, languages } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink-900 text-cream-100 border-t border-cream-100/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Massive wordmark */}
        <div className="pt-16 pb-12 border-b border-cream-100/10">
          <div
            data-testid="footer-wordmark"
            className="font-serif tracking-tighter leading-[0.85] text-cream-100"
            style={{ fontSize: "clamp(3.5rem, 14vw, 11rem)" }}
          >
            <span className="italic font-medium">Serkedjiev</span>{" "}
            <span className="font-medium">Law Office</span>
          </div>
        </div>

        <div className="py-10 grid md:grid-cols-3 gap-8 items-start">
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-cream-100/60">
              {t.footer.tagline}
            </div>
            <div className="mt-2 text-sm text-cream-100/70">{t.footer.built}</div>
          </div>

          <div className="md:text-center">
            <div className="text-sm text-cream-100/60">
              © {year} LAWSN. {t.footer.rights}
            </div>
          </div>

          <div className="md:text-right">
            <div
              role="group"
              aria-label="Language"
              className="inline-flex items-center gap-0 border border-cream-100/20"
            >
              {languages.map((l) => {
                const active = l.code === lang;
                return (
                  <button
                    key={l.code}
                    type="button"
                    data-testid={`footer-lang-${l.code}`}
                    onClick={() => setLang(l.code)}
                    className={`px-3 py-1.5 font-mono text-[11px] tracking-widest transition-colors ${
                      active
                        ? "bg-cream-100 text-ink-900"
                        : "text-cream-100 hover:bg-cream-100/10"
                    }`}
                  >
                    {l.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
